import type { FC, SVGProps } from 'react';

export type IconName =
    | 'info'
    | 'close'
    | 'close-filled'
    | 'zone-new-tag'
    | 'arrow-right'
    | 'arrow-left'
    | 'arrow'
    | 'favorites'
    | 'favorite-game'
    | 'fanduel-shield'
    | 'filter'
    | 'theme'
    | 'slots'
    | 'genre'
    | 'studio'
    | 'search-magnifying-glass'
    | 'plus'
    | 'social-tag'
    | 'account-details'
    | 'sound-off'
    | 'sound-on'
    | 'favorites-enhanced'
    | 'volatility-low'
    | 'volatility-medium'
    | 'volatility-high'
    | 'volatility-info'
    | 'site-wide-jackpot-toggle-on'
    | 'site-wide-jackpot-toggle-off'
    | 'site-wide-jackpot-slots'
    | 'site-wide-jackpot-trophy'
    | 'site-wide-jackpot-checkmark'
    | 'site-wide-jackpot-bolt'
    | 'site-wide-jackpot-bolt-radio'
    | 'site-wide-jackpot-glow-border'
    | 'exclusive-close-button'
    | 'error-hexagon'
    | 'play'
    | 'location-verification-pin'
    | 'location-verification-check'
    | 'location-verification-alert';

interface SvgLoaderProps extends SVGProps<SVGSVGElement> {
    iconName: IconName;
    directory?: string; // Optional subdirectory to look in (e.g., 'swj-icons', 'zone-icons')
    lineColor?: string; // Custom prop for SVG gradient colors
    importIcon?: (iconName: IconName, directory?: string) => FC<SVGProps<SVGSVGElement>> | null;
}

const defaultImportIcon = (iconName: IconName, directory?: string): FC<SVGProps<SVGSVGElement>> | null => {
    try {
        if (directory) {
            // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
            return require(`@/app/elements/svg/icons/${directory}/${iconName}.tsx`).default;
        }

        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        return require(`@/app/elements/svg/icons/${iconName}.tsx`).default;
    } catch {
        const locationInfo = directory ? `in directory "${directory}"` : 'in main icons directory';
        console.warn(`Icon "${iconName}" not found ${locationInfo}.`);
        return null;
    }
};

export const SvgLoader = ({ iconName, directory, importIcon = defaultImportIcon, ...svgProps }: SvgLoaderProps) => {
    const IconComponent = importIcon(iconName, directory);

    if (!IconComponent) {
        return null;
    }
    return <IconComponent {...svgProps} />;
};
